import React from 'react';
import style from './Plan.module.scss';
import { IPlan } from '../../model';
import classNames from 'classnames';

interface IProps {
  plan: {
    plan_id: string;
    features: IPlan['features']
  };
}

const PlanFeatures = ({plan}: IProps) => {
  return (
    <div className={style.features}>
      <div className={style.features_title}>Included</div>
      {window?.shortDescriptions?.[plan.plan_id] ?
        <div className={classNames(style.subscription_features, style.subscription_features__custom_html)}
             dangerouslySetInnerHTML={{__html: window?.shortDescriptions?.[plan.plan_id]}}/> :
        <div className={style.subscription_features}>
          {plan.features.join(', ')}
        </div>}
    </div>
  );
};

export default PlanFeatures;
